/**
 * Phone layout of a search-hit header row (name, open icon, then badges),
 * shared by the hit cards. From `md` none of it applies.
 */

/**
 * Wraps the badges after the name so they move to the next line as ONE group;
 * a long name never strands the last badge on a line of its own. From `md` the
 * wrapper dissolves (`contents`) and the badges are items of the header row.
 */
export const HIT_META_GROUP_CLASS = 'flex shrink-0 grow items-center gap-1.5 md:contents'

/**
 * Caps the name so what must stay on its line still fits: the open icon, plus
 * the trailing score or file count when no other badge precedes it.
 */
export const HIT_NAME_ROOM = {
  icon: 'max-md:max-w-[calc(100%-1.125rem)]',
  iconAndScore: 'max-md:max-w-[calc(100%-4.25rem)]',
  iconAndCount: 'max-md:max-w-[calc(100%-6rem)]',
} as const
